import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

export const Variant = {
  NONE: 'none',
  FEEDBACK: 'feedback',
  REVIEWS: 'reviews',
};

const IntContainer = styled.div`
  display: flex;
  alignitems: center;
  justifycontent: center;
  width: 100%;
  height: 55px;
  margin: 5px 2px;

  cursor: pointer;

  ${legacyTheme.breakpoints.up('sm')} {
    width: 56px;
    height: 56px;
    margin: 5px;
  }
`;

type PathProps = {
  d?: string;
  d1?: string;
  d2?: string;
  fill?: string;
  style?: {};
};

export type VariantType = (typeof Variant)[keyof typeof Variant];

type StarProps = {
  dataValue?: number;
  fillBackground?: string;
  fillColor?: string;
  fillPercent?: number;
  index?: number;
  style?: {
    background?: string;
    fill?: string;
  };
  variant?: VariantType;
};

export const Star = ({
  dataValue,
  fillColor,
  fillBackground,
  fillPercent,
  index,
  style,
  variant = Variant.NONE,
}: StarProps) => {
  const isFeedback = variant === Variant.FEEDBACK;
  const isReviews = variant === Variant.REVIEWS;
  const pathProps: PathProps = isFeedback
    ? {
        d1: 'M123 0h40v40h-40z',
        d2: 'M30 37l-8 4 2-8-6-6 8-1 4-8 4 8 8 1-6 6 1 8z',
      }
    : isReviews
    ? {
        d: 'M6.309 0L4.379 3.977 0 4.584 3.186 7.648 2.41 12 6.309 9.917 10.208 12 9.432 7.648 12.618 4.584 12.618 4.584 8.239 3.977 6.309 0z',
      }
    : {
        d: 'M9.9 1.1L3.3 21.78l16.5-13.2H0l16.5 13.2',
        style: style || {},
      };

  let defs = null;
  if (fillPercent != null) {
    if (fillPercent === 0) {
      pathProps.fill = fillBackground;
    } else if (fillPercent === 100) {
      pathProps.fill = fillColor;
    } else {
      pathProps.fill = 'url(#gradient)';
      defs = (
        <linearGradient id="gradient">
          <stop offset="0%" stopColor={fillColor} />
          <stop offset={`${fillPercent}%`} stopColor={fillColor} />
          <stop offset={`${fillPercent}%`} stopColor={fillBackground} />
          <stop offset="100%" stopColor={fillBackground} />
        </linearGradient>
      );
    }
  }

  if (index) {
    return (
      <IntContainer data-value={dataValue} style={style}>
        {index + 1}
      </IntContainer>
    );
  }

  if (isFeedback && style) {
    return (
      <svg data-testid="star" data-value={dataValue} height="50" width="50">
        <defs>
          <filter height="175%" id="a" width="175%" x="-38%" y="-38%" />
        </defs>
        <g fill="none" fillRule="evenodd">
          <g transform="translate(-113 10)">
            <path d={pathProps.d1} fill={style.fill} id="b" {...pathProps} />
          </g>
          <path
            d={pathProps.d2}
            fill={theme.colors.neutral['100']}
            stroke={theme.colors.neutral['100']}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    );
  }

  const [width, height] = isReviews ? [12.62, 12] : [25, 23];

  return (
    <svg data-value={dataValue} height={height} width={width}>
      <defs>{defs}</defs>
      <path {...pathProps} />
    </svg>
  );
};
